export default [
  {
    title: 'Home',
    route: 'home',
    icon: 'HomeIcon',
  },
  {
    title: 'Hubs',
    route: 'hubs',
    icon: 'PackageIcon',
  },
  {
    title: 'Producers',
    route: 'producers',
    icon: 'ArchiveIcon',
  },
  {
    title: 'Products',
    route: 'products',
    icon: 'ListIcon',
  },
  {
    title: 'Orders',
    route: 'orders',
    icon: 'ShoppingCartIcon',
  },
  {
    title: 'Invoices',
    route: 'invoices',
    icon: 'FileTextIcon',
  },
  {
    title: 'Invoices Corrections',
    route: 'invoices-corrections',
    icon: 'FileMinusIcon',
  },
  {
    title: 'Export Data',
    route: 'export-data',
    icon: 'DownloadIcon',
  },
  {
    title: 'User Management',
    route: 'user-management',
    icon: 'UserIcon',
  },
  {
    title: 'Nanostore',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Entrance History',
        route: 'nanostore-entrance-history',
        icon: 'ClockIcon',
      },
      {
        title: 'Unfinished orders',
        route: 'nanostore-unfinished-orders',
        icon: 'AlertCircleIcon',
      },
      {
        title: 'Settings',
        icon: 'SettingsIcon',
        children: [
          {
            title: 'General',
            route: 'nanostore-settings-general',
            icon: 'SettingsIcon',
          },
          {
            title: 'Connections',
            route: 'nanostore-settings-connections',
            icon: 'LinkIcon',
          },
          {
            title: 'Relays',
            route: 'nanostore-settings-relays',
            icon: 'Share2Icon',
          },
        ],
      },
    ],
  },
]
